import { getElement } from 'onboarding-tours/util/elementUtil';
import { waitForElementToAppear } from 'onboarding-tours/util/mutationUtil';
import { waitForElementToDisappear } from './util';
import { TourCompletionStatus } from 'onboarding-tours-client/constants';
import { getTourStatus, setTourStatus } from 'onboarding-tours-client/onboardingToursClient';
const FOLDERS_BUTTON = '[data-test-id="crm-listing-folder-tab"]';
const CREATE_FOLDER_BUTTON = '[data-test-id="crm-listing-create-folder-button"]';
export const EMAIL_FRAMEWORK_FOLDERS_TOUR_ID = 'email-framework-folders-tour';
const frameworkFoldersTour = () => ({
  active: true,
  alias: 'email-framework-folders-tour',
  i18nPrefix: 'email-framework-folders-tour',
  // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
  tourUrl: 'https://app.hubspot.com/l/manage/folders',
  owningTeam: 'hs-messaging-management-fe',
  beforeExit: () => {
    void setTourStatus(EMAIL_FRAMEWORK_FOLDERS_TOUR_ID, TourCompletionStatus.COMPLETE);
  },
  steps: [
  //Step 1: Point at folders button
  {
    text: true,
    title: true,
    showSteps: false,
    isModal: true,
    attachTo: {
      elementQuery: FOLDERS_BUTTON,
      on: 'bottom'
    },
    beforeStart: async ({
      tour
    }) => {
      const tourStatus = await getTourStatus(EMAIL_FRAMEWORK_FOLDERS_TOUR_ID);
      if (tourStatus.status === TourCompletionStatus.COMPLETE) {
        tour.finish();
      }
      if (window.location.pathname.includes('/manage/folders')) {
        tour.next();
      }
    },
    waitForElement: () => waitForElementToAppear({
      elementQuery: '[data-selenium-test="QuickFiltersBar-item-more"]'
    }),
    pulser: true,
    buttonSize: 'sm',
    actionText: false,
    eventHandlers: [{
      event: 'click',
      elementQuery: FOLDERS_BUTTON,
      action: 'next'
    }]
  },
  //Step 2: Point at create folders button
  {
    text: true,
    title: true,
    beforeStart: () => {
      const folderButton = getElement({
        elementQuery: FOLDERS_BUTTON
      });
      if (folderButton) {
        folderButton.click();
      }
    },
    pulser: true,
    attachTo: {
      elementQuery: CREATE_FOLDER_BUTTON,
      on: 'bottom'
    },
    buttonSize: 'sm',
    enableBackButton: true,
    eventHandlers: [{
      event: 'click',
      elementQuery: CREATE_FOLDER_BUTTON,
      action: 'next'
    }]
  },
  //Step 3: Point at asset for drag
  {
    text: true,
    title: true,
    attachTo: {
      elementQuery: '[data-test-id="crm-listing-folders"]',
      on: 'right'
    },
    buttonSize: 'sm',
    pulser: true,
    enableBackButton: true,
    waitForElement: async () => {
      await waitForElementToAppear({
        elementQuery: '[data-test-id="crm-listing-folder-modal"]'
      });
      return waitForElementToDisappear('[data-test-id="crm-listing-folder-modal"]');
    },
    buttons: [{
      commonText: 'next',
      action: 'next'
    }]
  },
  //Step 4: Point at unfiled assets
  {
    text: true,
    title: true,
    attachTo: {
      elementQuery: '[data-test-id="crm-listing-search-input"]',
      on: 'right'
    },
    buttonSize: 'md',
    enableBackButton: true,
    pulser: true,
    buttons: [{
      text: true,
      action: 'finish'
    }]
  }]
});
export default frameworkFoldersTour;